import { useEffect, useRef, useState } from 'react';
import MachineStatus from '../components/MachineStatusComponent/MachineStatus.component';
import { useSelector } from 'react-redux';
import { selectUser } from '../utils/redux/userSlice';
import { Machine } from '../utils/models/Machine';
import { useLocation, useOutletContext, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getMachinesByCompany } from '../utils/services/machine.service';
import { getInstalationsByCompany } from '../utils/services/instalation.service';
import { IOutletContext } from '../utils/interfaces/IOutletContext';
import { MachineData } from '../utils/models/MachineData';
import { getAllDataByDates, getGraphData } from '../utils/services/data.service';
import { downloadFile, generateCSVData } from '../utils/libs/filesFunc';
import { format } from 'date-fns';
import { DashboardTypes, MachineConected } from 'aw-consts';
import { getLast7days, getTodayDate } from 'aw-date-functions';
import { getRandomNumber, orderByLabel } from 'aw-generic-functions';
import { Spinner } from 'react-bootstrap';
import { AWGrid, TableData } from 'aw-grid';
import CharD3, { charData } from '../components/CharProductionComponent/charD3.component';
import MachineCardDetail from '../components/MachinesComponents/MachineCardDetail/MachineCardDetail.component';
import MachineCardAllMeasures from '../components/MachinesComponents/MachineCardAllMeasures/MachineCardAllMeasures.component';
import ModalDataCard from '../components/ModalDataCard/ModalDataCard.component';
import { DataCard, IDataItem } from 'aw-data-card';
import { GraphLine, ICharData, ICharOptions } from 'aw-graph';
import { MapComponent } from 'aw-map';
import { useTheme } from '../utils/contexts/ThemeContext';
import { ISelectOptions } from 'aw-combobox';
import CardSchedules from '../components/CardSchedules/CardSchedules/CardSchedules.component';
// import { UserButtonsLine } from 'aw-user-buttons-line';
import IAChat, { PredefinedQuestions } from '../components/IAChat/IAChat.component';
import { Instalation } from '../utils/models/Instalation';
import { UserButtonsLine } from 'aw-user-buttons-line';

const getRandomMixedData1 = [
    { label: 'Coolant Temperature', value: String(Math.round(Math.random() * 60 + 40)), unit: 'ºC', type: 'number', min: 40, max: 100 },
    { label: 'Chamber Pressure', value: String(Math.round(Math.random() * 800 + 200)), unit: 'kPa', type: 'number', min: 200, max: 1000 },
    { label: 'Humidity Level', value: String(Math.round(Math.random() * 60 + 20)), unit: '%', type: 'number', min: 20, max: 80 },
    { label: 'Valve Opening', value: String(Math.round(Math.random() * 100)), unit: '%', type: 'number', min: 0, max: 100 },
    {
        label: 'Operating Mode',
        value: 'manual',
        type: 'select',
        options: [
            { value: 'manual', label: 'Manual' },
            { value: 'auto', label: 'Automatic' },
            { value: 'test', label: 'Test' },
            { value: 'maintenance', label: 'Maintenance' },
            { value: 'offline', label: 'Offline' },
        ],
    },
    { label: 'Operator Note', value: 'Initial check done', type: 'text' },
    { label: 'Calibration Date', value: new Date().toISOString().split('T')[0], type: 'date' },
    { label: 'Flow Rate', value: String(Math.round(Math.random() * 90 + 10)), unit: 'L/min', type: 'number', min: 10, max: 100 },
    { label: 'Efficiency', value: String(Math.round(Math.random() * 20 + 80)), unit: '%', type: 'number', min: 80, max: 100 },
    { label: 'Pressure Drop', value: String(Math.round(Math.random() * 300 + 50)), unit: 'Pa', type: 'number', min: 50, max: 350 },
    { label: 'Motor Speed', value: String(Math.round(Math.random() * 2000 + 500)), unit: 'RPM', type: 'number', min: 500, max: 2500 },
];

const getRandomMixedData2 = [
    { label: 'Battery Voltage', value: String((Math.random() * 6 + 18).toFixed(2)), unit: 'V', type: 'number', min: 18, max: 24 },
    { label: 'Current Draw', value: String((Math.random() * 40 + 10).toFixed(1)), unit: 'A', type: 'number', min: 10, max: 50 },
    {
        label: 'System Status',
        value: 'online',
        type: 'select',
        options: [
            { value: 'online', label: 'Online' },
            { value: 'offline', label: 'Offline' },
            { value: 'maintenance', label: 'Maintenance' },
            { value: 'error', label: 'Error' },
        ],
    },
    { label: 'Last Maintenance', value: new Date(Date.now() - 86400000 * 30).toISOString().split('T')[0], type: 'date' },
    { label: 'Temperature Sensor', value: String(Math.round(Math.random() * 40 + 10)), unit: 'ºC', type: 'number', min: 10, max: 50 },
    { label: 'Humidity Sensor', value: String(Math.round(Math.random() * 40 + 30)), unit: '%', type: 'number', min: 30, max: 70 },
    { label: 'Alarm Threshold', value: String(Math.round(Math.random() * 2 + 2)), unit: '%', type: 'number', min: 2, max: 4 },
    { label: 'Notes', value: 'Routine check OK', type: 'text' },
    { label: 'Fan Speed', value: String(Math.round(Math.random() * 3000 + 1000)), unit: 'RPM', type: 'number', min: 1000, max: 4000 },
];

const getRandomMixedData3 = [
    { label: 'Water Level', value: String(Math.round(Math.random() * 50 + 40)), unit: '%', type: 'number', min: 40, max: 90 },
    { label: 'PH Level', value: String((Math.random() * 2 + 6).toFixed(2)), type: 'number', min: 6, max: 8 },
    {
        label: 'Valve Status',
        value: 'open',
        type: 'select',
        options: [
            { value: 'open', label: 'Open' },
            { value: 'closed', label: 'Closed' },
            { value: 'partial', label: 'Partial' },
        ],
    },
    { label: 'Filter Change Date', value: new Date(Date.now() - 86400000 * 90).toISOString().split('T')[0], type: 'date' },
    { label: 'Flow Rate', value: String(Math.round(Math.random() * 100 + 20)), unit: 'L/min', type: 'number', min: 20, max: 120 },
    { label: 'System Pressure', value: String(Math.round(Math.random() * 800 + 400)), unit: 'kPa', type: 'number', min: 400, max: 1200 },
    { label: 'Operator Comments', value: 'Filter replaced recently', type: 'text' },
];


const randomDataTwoPages = [
    {
        name: 'General Settings',
        data: getRandomMixedData1,
    },
    {
        name: 'System Metrics',
        data: getRandomMixedData2,
    },
];

const randomDataOnePageA = [
    {
        name: 'Water System',
        data: getRandomMixedData3,
    },
];

const randomDataOnePageB = [
    {
        name: 'General Settings',
        data: getRandomMixedData1,
    },
];

const UserMachinesPage = () => {
    const { t } = useTranslation();

    const allCharOptions: ICharOptions[] = [
        { label: `${t('Measure')} 1`, key: 'Mesure 1', color: '#8884d8', units: 'ºC', minValue: 0, maxValue: 1400, value: 0 },
        { label: `${t('Measure')} 2`, key: 'Mesure 2', color: '#FF851B', units: '%', minValue: 0, maxValue: 1050, value: 1 },
        { label: `${t('Measure')} 3`, key: 'Mesure 3', color: '#ffc658', units: 'hPa', minValue: 300, maxValue: 900, value: 2 },
        { label: `${t('Measure')} 4`, key: 'Mesure 4', color: '#33f502', units: 'ppm', minValue: 0, maxValue: 500, value: 3 },
        { label: `${t('Measure')} 5`, key: 'Mesure 5', color: '#ff4136', units: 'µg/m³', minValue: 0, maxValue: 500, value: 4 },
    ];

    const predefinedQuestions: PredefinedQuestions[] = [
        {
            question: 'Whatisthecurrentstatusofthemachine',
            response: 'Themachineiscurrentlyoperatingwithinnormalparameterswithnodetectedissues'
        },
        {
            question: 'Havetherebeenrecenterrors',
            response: 'Norecenterrorshavebeendetected'
        },
        {
            question: 'Whatisthecurrenttemperature',
            response: 'Thecurrenttemperatureis72°C'
        }
    ];

    const user = useSelector(selectUser);
    const [machines, setMachines] = useState<Machine[]>([]);
    const [machine, setMachine] = useState<Machine>(new Machine());
    const [allMachinesObj, setAllMachinesObj] = useState<ISelectOptions[]>([]);
    const [allMachinesUnfiltered, setAllMachinesUnfiltered] = useState<ISelectOptions[]>([]);
    const [allInstalationsObj, setAllInstalationsObj] = useState<ISelectOptions[]>([]);
    const [selectedMachine, setSelectedMachine] = useState<ISelectOptions>();
    const [selectedInstalation, setSelectedInstalation] = useState<ISelectOptions>();
    const [allData, setAllData] = useState<MachineData[]>([]);
    const [iniDate, setIniDate] = useState(getLast7days());
    const [finDate, setFinDate] = useState(getTodayDate());
    const [loadingData, setLoadingData] = useState(true);
    const [selectedCharOptions, setSelectedCharOptions] = useState<ICharOptions[]>(allCharOptions.slice(0, 2));
    const [charData, setCharData] = useState<ICharData[]>([]);
    const context: IOutletContext = useOutletContext();
    const { idmachine } = useParams();
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState<IDataItem[] | any>(randomDataTwoPages);
    const refElementScroll = useRef<HTMLDivElement>(null);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const isModule = searchParams.get('isModule');
    const machineIdFromQuery = searchParams.get('idmachine');
    const selectedMachineId = machineIdFromQuery || idmachine;
    const theme = useTheme();

    const tableHeaders = [t('Date'), t('Machine'), t('Installation'), t('Operation')];
    const tableBody: TableData[] = [
        { item: [1, format(new Date().setHours(new Date().getHours() - 1), 'dd/MM/yyyy HH:mm'), 'Equipo 1', 'Awayter', 'Operation 1'], active: true },
        {
            item: [2, format(new Date().setHours(new Date().getHours() - 2), 'dd/MM/yyyy HH:mm'), 'Equipo 3', 'Jaén 232', 'Operation 2'],
            active: true,
        },
        {
            item: [3, format(new Date().setHours(new Date().getHours() - 3), 'dd/MM/yyyy HH:mm'), 'Equipo 5', 'Lleida 261', 'Operation 3'],
            active: true,
        },
        {
            item: [4, format(new Date().setHours(new Date().getHours() - 4), 'dd/MM/yyyy HH:mm'), 'Equipo 3', 'Salamanca 762', 'Operation 4'],
            active: true,
        },
        {
            item: [5, format(new Date().setHours(new Date().getHours() - 5), 'dd/MM/yyyy HH:mm'), 'Equipo 2', 'Lisboa 596', 'Operation 5'],
            active: true,
        },
        {
            item: [6, format(new Date().setHours(new Date().getHours() - 6), 'dd/MM/yyyy HH:mm'), 'Equipo 7', 'Budapest 854', 'Operation 6'],
            active: true,
        },
        {
            item: [7, format(new Date().setHours(new Date().getHours() - 7), 'dd/MM/yyyy HH:mm'), 'Equipo 8', 'Berlín 845', 'Operation 7'],
            active: true,
        },
        {
            item: [8, format(new Date().setHours(new Date().getHours() - 8), 'dd/MM/yyyy HH:mm'), 'Equipo 6', 'Roma 426', 'Operation 8'],
            active: true,
        },
        { item: [9, format(new Date().setHours(new Date().getHours() - 9), 'dd/MM/yyyy HH:mm'), 'Equipo 5', 'Awayter', 'Operation 9'], active: true },
    ];

    const getCharData = (): charData[] => {
        const charData: charData[] = [];
        const now = new Date();
        now.setDate(now.getDate() - 6);
        for (let i = 0; i < 7; i++) {
            charData.push({ date: `${now.getDate()}/${now.getMonth() + 1}`, numItems: getRandomNumber(0, 100) });
            now.setDate(now.getDate() + 1);
        }

        return charData;
    };

    useEffect(() => {
        context.setState(t('Machines'));
    });

    useEffect(() => {
        if (loadingData && machine.idmachine > 0) {
            // getLastData(user.token, machine.idmachine, DashboardTypes.Machine)
            //     .then((md: MachineData) => setData(md))
            //     .catch((e) => console.error('Error getLastData', e))
            //     .finally(() => {
            //         setTimeout(() => {
            //             setLoadingData(false)
            //         }, 250)
            //     })

            getAllDataByDates(user.token, machine.idmachine, iniDate, finDate, DashboardTypes.Machine)
                .then((md: MachineData[]) => setAllData(md))
                .catch(e => console.error('Error getAllDataByDates', e))
                .finally(() => {
                    setTimeout(() => {
                        setLoadingData(false);
                    }, 250);
                });
        }
    }, [loadingData, machine]);

    useEffect(() => {
        getGraphData(user.token, iniDate, finDate, JSON.stringify(allCharOptions))
            .then((data: ICharData[]) => {
                setCharData(data);
            })
            .catch(e => {
                console.error('Error getElectricalDataChar', e);
            })
            .finally(() => {
                setTimeout(() => {
                    setLoadingData(false);
                }, 250);
            });
    }, [selectedCharOptions]);

    useEffect(() => {
        getInstalationsByCompany(user.token, user.company.idcompany)
            .then((instalations: Instalation[]) => {
                // Filtrar solo instalaciones que tengan máquinas
                const instalationsWithMachines = instalations.filter((i: Instalation) =>
                    machines.some((m: Machine) =>
                        Number(m.instalation?.idinstalation) === Number(i.idinstalation)
                    )
                );

                const instalationOptions = orderByLabel(
                    instalationsWithMachines.map((i: Instalation) => ({ label: i.name, value: Number(i.idinstalation) }))
                );

                setAllInstalationsObj(instalationOptions);

                if (instalationOptions.length === 0) {
                    setSelectedInstalation(undefined);
                }
                // No establecemos automáticamente la primera instalación
                // Dejamos que sea la máquina seleccionada la que determine la instalación
            })
            .catch(e => {
                console.error('Get UserInstallations', e);
            });
    }, [machines]);

    useEffect(() => {
        if (isModule === '1') {
            if (refElementScroll.current) {
                refElementScroll.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
        }

        getMachinesByCompany(user.token, user.company.idcompany)
            .then((machines: Machine[]) => {
                const allMachinesObjAux: ISelectOptions[] = [];
                const machinesAux: Machine[] = [];

                machines.forEach((m: Machine) => {
                    allMachinesObjAux.push({ label: m.name, value: m.idmachine });
                    machinesAux.push(m);
                });

                const machinesObjOrd = orderByLabel(allMachinesObjAux);
                setAllMachinesUnfiltered(machinesObjOrd);
                setAllMachinesObj(machinesObjOrd);
                setMachines(machinesAux);

                if (machinesAux.length === 0 || machinesObjOrd.length === 0) {
                    setMachine(new Machine());
                    setSelectedMachine(undefined);
                    return;
                }

                const lastMachineIdSelected = localStorage.getItem('lastMachineIdSelected');
                const selectedMachineIdOk = selectedMachineId || lastMachineIdSelected;

                const machineFromParam = selectedMachineIdOk
                    ? machinesAux.find((m: Machine) => m.idmachine === Number(selectedMachineIdOk))
                    : undefined;
                const optionFromParam = selectedMachineIdOk
                    ? machinesObjOrd.find((m: ISelectOptions) => Number(m.value) === Number(selectedMachineIdOk))
                    : undefined;

                const fallbackMachine = machinesAux[0];
                const fallbackOption = machinesObjOrd[0];
                const nextMachine = machineFromParam || fallbackMachine;
                const nextOption = optionFromParam || fallbackOption;

                setMachine(nextMachine);
                setSelectedMachine({ ...nextOption, value: Number(nextOption.value) });
                localStorage.setItem('lastMachineIdSelected', nextOption?.value.toString() ?? '');
            })
            .catch(e => {
                console.error('Get UserMachines', e);
            })
            .finally(() => {
                setTimeout(() => {
                    setLoadingData(false);
                }, 250);
            });
    }, []);

    useEffect(() => {
        const machinesAux: Machine[] = machines.filter((machine: Machine) => machine.idmachine === Number(selectedMachine?.value));
        if (machinesAux.length > 0) {
            setLoadingData(true);
            setMachine(machinesAux[0]);
            setTimeout(() => {
                setLoadingData(false);
            }, 500);
        }
        const interval = setInterval(() => {
            setLoadingData(true);
            setTimeout(() => {
                setLoadingData(false);
            }, 500);
        }, 300000); //300000 -> 5min   30000 -> 30s

        return () => {
            clearInterval(interval);
        };
    }, [selectedMachine, machines]);

    // Sincronizar instalación cuando la máquina está lista
    useEffect(() => {
        if (machine.idmachine > 0 && machine.instalation && allInstalationsObj.length > 0) {
            const instalationOption = allInstalationsObj.find((i: ISelectOptions) =>
                Number(i.value) === Number(machine.instalation.idinstalation)
            );
            if (instalationOption && (!selectedInstalation || Number(selectedInstalation.value) !== Number(instalationOption.value))) {
                setSelectedInstalation({ ...instalationOption, value: Number(instalationOption.value) });
            }
        }
    }, [machine, allInstalationsObj]);

    // Filtrar máquinas según la instalación seleccionada
    useEffect(() => {
        if (allMachinesUnfiltered.length === 0) {
            return;
        }

        // Si no hay instalación seleccionada, mostrar todas las máquinas
        if (!selectedInstalation) {
            setAllMachinesObj(allMachinesUnfiltered);
            return;
        }

        const filteredMachines = machines.filter((m: Machine) =>
            Number(m.instalation?.idinstalation) === Number(selectedInstalation.value)
        );

        const filteredOptions = allMachinesUnfiltered.filter((option: ISelectOptions) =>
            filteredMachines.some((m: Machine) => m.idmachine === Number(option.value))
        );

        setAllMachinesObj(filteredOptions);

        // Si la máquina seleccionada no está en las filtradas, seleccionar la primera de la lista filtrada
        if (selectedMachine && !filteredOptions.some((o: ISelectOptions) => Number(o.value) === Number(selectedMachine.value))) {
            if (filteredOptions.length > 0) {
                const firstOption = filteredOptions[0];
                setSelectedMachine({ ...firstOption, value: Number(firstOption.value) });
                localStorage.setItem('lastMachineIdSelected', firstOption.value.toString());

                const firstMachine = filteredMachines.find((m: Machine) => m.idmachine === Number(firstOption.value));
                if (firstMachine) {
                    setMachine(firstMachine);
                }
            }
        }
    }, [selectedInstalation, allMachinesUnfiltered, machines]);

    const selectMachine = (selectedMachine: ISelectOptions) => {
        localStorage.setItem('lastMachineIdSelected', selectedMachine?.value.toString() ?? '');
        setSelectedMachine(selectedMachine);

        // Actualizar la instalación seleccionada según la máquina seleccionada
        const machineObj = machines.find((m: Machine) => m.idmachine === Number(selectedMachine.value));
        if (machineObj && machineObj.instalation) {
            const instalationOption = allInstalationsObj.find((i: ISelectOptions) =>
                Number(i.value) === Number(machineObj.instalation.idinstalation)
            );
            if (instalationOption) {
                setSelectedInstalation({ ...instalationOption, value: Number(instalationOption.value) });
            }
        }
    }
    const onChangeCombo = (e: any) => {
        const parsedValue = Number(e.value);
        const selectedValue = allMachinesObj.find((m: ISelectOptions) => Number(m.value) === parsedValue);
        if (selectedValue) {
            selectMachine({ ...selectedValue, value: Number(selectedValue.value) });
        }
    };

    const onChangeCombo2 = (e: any) => {
        const parsedValue = Number(e.value);
        const selectedValue = allInstalationsObj.find((i: ISelectOptions) => Number(i.value) === parsedValue);
        if (selectedValue) {
            setSelectedInstalation({ ...selectedValue, value: Number(selectedValue.value) });
        }
    };

    const onChangeDates = (e: any) => {
        if (e.target.name === 'iniDate') {
            setIniDate(e.target.value);
        } else if (e.target.name === 'finDate') {
            setFinDate(e.target.value);
        }
    };

    const onClickRefresh = () => {
        setLoadingData(true);
        setTimeout(() => {
            setLoadingData(false);
        }, 500);
    };

    const updateMachineLastConnection = (lastConnection: Date) => {
        setMachine(prevValue => ({
            ...prevValue,
            last_conection: lastConnection,
        }));
    };

    const downloardData = () => {
        downloadFile(generateCSVData(allData, `${t('Machine')};${t('Day')};${t('Hour')};${t('Quality')};${t('Co2')};${t('PM10')};${t('Temperature')};${t('Humidity')}\n`), `${format(new Date(), 'ddMMyyyyHHmm')}_${t('Data')}.csv`);
    };

    return (
        <>
            <IAChat machineId={machine.idmachine} predefinedQuestions={predefinedQuestions} />
            <div className="row border-0 ms-2 me-2" style={{ maxWidth: '100%' }}>
                <div className="col-12 col-md-12 p-1">
                    <UserButtonsLine
                        downloardData={downloardData}
                        role={user.role}
                        connected={MachineConected.Conected}
                        defaultIni={iniDate}
                        defaultFin={finDate}
                        onChangeDates={onChangeDates}
                        DashboardType={DashboardTypes.Machine}
                        onClickReload={onClickRefresh}
                        onChangeSelect={onChangeCombo}
                        options={allMachinesObj}
                        selected={selectedMachine || allMachinesObj[0]}
                        showOptions2={true}
                        onChangeSelect2={onChangeCombo2}
                        options2={allInstalationsObj}
                        selected2={selectedInstalation || allInstalationsObj[0]}
                        changeView={() => null}
                        rounded="rounded-1"
                        classNameSecondary="btn-Custom btn-Grey"
                        classNameSuccess="btn-Custom btn-IDGreen"
                        containerColor="var(--background-secondary)"
                        dark={theme.theme === 'dark' ? true : false}
                    />
                </div>
            </div>
            <div className="row border-0 ms-2 me-2" style={{ maxWidth: '100%' }}>
                <div className="col-12 col-lg-4 px-1 mt-1">
                    <MachineStatus updLastConnection={updateMachineLastConnection} id={machine.idmachine} token={user.token} refresh={loadingData} title={t('State2')} dashboardType={DashboardTypes.Machine} user={user} iniDate={iniDate} finDate={finDate} />
                </div>
                <div className="col-12 col-lg-4 px-1 mt-1" style={{ height: '500px' }}>
                    <MachineCardDetail machine={machine} refresh={loadingData} />
                </div>
                <div className="col-12 col-lg-4 px-1 mt-1" style={{ height: '500px' }}>
                    <MachineCardAllMeasures machine={machine} refresh={loadingData} />
                </div>
            </div>
            <div className="row border-0 ms-2 me-2" style={{ maxWidth: '100%' }}>
                <div className="col-12 col-md-4 px-1 mt-2">
                    <AWGrid loading={loadingData} noDataText={t('NoData')} onDeleteClick={() => null} onEditClick={() => null} tableData={tableBody} tableHeaders={tableHeaders} bgColor="var(--background-secondary)" textColor="var(--text-primary)" title={t('Operations')} manage={false} gridStyle="gridsStyle" spinnerColor="var(--accent-color)" />
                </div>
                <div className="col-12 col-md-8 mt-1 p-1">
                    <CharD3 dataChar={getCharData()} loading={loadingData} capture={false} title={t('OperationsForDay')} setPNGChar={() => null} />
                </div>
            </div>
            <div className="row border-0 mx-2 my-1" style={{ minHeight: '45vh' }}>
                <div className="col-12 px-1">
                    <GraphLine refresh={loadingData} showDots={false} showSelect={true} options={allCharOptions} prevSelectedOptions={selectedCharOptions} data={charData} onChangeSelectedOptions={setSelectedCharOptions} lineChartMarginLeft={40} lineChartMarginRight={40} spinnerColor="var(--IDGreen)" backgroundColor="var(--background-secondary)" textColor="var(--text-primary)" />
                </div>
            </div>
            <div className="row border-0 ms-2 me-2 align-items-stretch">
                <ModalDataCard showModal={showModal} data={modalData} onSave={() => setShowModal(false)} onClose={() => setShowModal(false)}></ModalDataCard>

                <div className="col-12 col-md-4 p-1 d-flex">
                    <div className="w-100 h-100">
                        <DataCard
                            name={t('Orders')}
                            backgroundColor="var(--background-secondary)"
                            textColor="var(--text-primary)"
                            data={randomDataTwoPages[0].data}
                            showButton={true}
                            buttonStyle="btn-Custom btn-IDGreen"
                            iconName="bi bi-pencil"
                            onOpenModal={() => {
                                setModalData(randomDataTwoPages);
                                setShowModal(true);
                            }}
                        />
                    </div>
                </div>
                <div className="col-12 col-md-4 p-1 d-flex">
                    <div className="w-100 h-100">
                        <CardSchedules idmachine={''} token={''} />
                    </div>
                </div>
                <div className="col-12 col-md-4 p-1 d-flex">
                    <div className="w-100 h-100">
                        <DataCard
                            name={t('Slogan')}
                            backgroundColor="var(--background-secondary)"
                            textColor="var(--text-primary)"
                            data={randomDataOnePageB[0].data}
                            showButton={true}
                            buttonStyle="btn-Custom btn-IDGreen"
                            iconName="bi bi-gear"
                            onOpenModal={() => {
                                setModalData(randomDataOnePageB);
                                setShowModal(true);
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="row border-0 ms-2 me-2 mb-2" style={{ maxWidth: '100%' }}>
                <div className="col-12 col-md-12 p-1" ref={refElementScroll}>
                    <div
                        className="p-2 rounded-1"
                        style={{
                            backgroundColor: 'var(--background-secondary)',
                            height: '500px',
                            width: '100%',
                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
                        }}
                    >
                        {loadingData ? (
                            <div className="text-center pt-5">
                                <Spinner animation="border" variant="success" />
                            </div>
                        ) : (
                            <MapComponent
                                url={'userInstalations'}
                                allPositions={[
                                    {
                                        lat: machine.instalation.lat,
                                        lng: machine.instalation.lng,
                                        id: machine.instalation.idinstalation,
                                        name: machine.instalation.name,
                                        iconColor: '#008000',
                                        letter: '1',
                                    },
                                ]}
                                enable={true}
                                position={{ lat: machine.instalation.lat, lng: machine.instalation.lng }}
                                setPosition={() => {
                                    return false;
                                }}
                                showAllPositions={true}
                                iconSize={30}
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserMachinesPage;
